export const setCurrentArea = (currentArea) => async (dispatch) => {
  dispatch({
    type: "SET_CURRENT_AREA",
    currentArea,
  });
};
